var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'block-card': true, selected: _vm.selected},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._m(0),_c('div',{staticClass:"block-card-name"},[_c('router-link',{attrs:{"to":{
        name: 'EditBlock',
        params: {
          siteId: _vm.block.siteId,
          blockId: _vm.block.id
        }
      }}},[_vm._v("\n      "+_vm._s(_vm.block.name)+"\n    ")])],1),_c('div',{staticClass:"block-card-description"},[_vm._v("\n    "+_vm._s(_vm.block.description)+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-card-icon"},[_c('i',{staticClass:"el-icon-fa-cube"})])}]

export { render, staticRenderFns }